import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import MobileSidebar from './MobileSidebar'
import MobileHeader from './MobileHeader'
import BottomNavigation from './BottomNavigation'

export default function MobileLayout({ children }) {
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const isFullBleedRoute = /^\/(clinicas|suscripciones-clinicas)(\/|$)/.test(location.pathname)
  const hideHeaderOnRoute = [
    '/',
    '/citas',
    '/notificaciones',
    '/suscripciones-clinicas',
    '/perfil',
    '/perfil/editar'
  ].includes(location.pathname) || /^\/(mascotas|citas|fichas)\/[^/]+$/.test(location.pathname) || isFullBleedRoute
  // Mantener navegación inferior visible en clínicas para mejorar descubribilidad.
  const hideBottomNav = false

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024) // alineado con PageWrapper/GlobalLayout
      // En desktop, mantener el sidebar abierto por defecto
      if (window.innerWidth >= 1024) {
        setSidebarOpen(true)
      }
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev)
  }

  const closeSidebar = () => {
    // Solo cerrar en mobile, en desktop mantener abierto
    if (isMobile) {
      setSidebarOpen(false)
    }
  }

  return (
    <div className="h-[100dvh] min-h-[100dvh] flex overflow-hidden bg-white">
      {/* Sidebar - Funciona en todos los tamaños */}
      <MobileSidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0 relative">
        {/* Header */}
        {!hideHeaderOnRoute && <MobileHeader onMenuToggle={toggleSidebar} />}

        {/* Page Content */}
        <main className={`flex-1 ${isFullBleedRoute ? `overflow-hidden bg-white ${hideBottomNav ? 'pb-6' : 'pb-[86px]'}` : `overflow-y-auto bg-white ${hideBottomNav ? 'pb-6' : 'pb-[86px]'}`}`}>
          <div className={isFullBleedRoute ? 'h-full w-full' : 'w-full'}>
            {children}
          </div>
        </main>

        {/* Bottom Navigation Bar - Centrado solo en el área de contenido */}
        {!hideBottomNav && (
          <div className="absolute bottom-0 left-0 right-0 pb-[env(safe-area-inset-bottom)]">
            <BottomNavigation />
          </div>
        )}
      </div>
    </div>
  )
}
